import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetExecutorsParams } from './types'
import type { ExecutorDto } from './dtos'

const URL = '/internal-tasks/executors/'

export const getExecutors: AblePaginatedResponseFn<GetExecutorsParams, ExecutorDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
